module.exports = __webpack_public_path__ + "static/media/settings--light.fc6b2a9e.svg";